import type { ButtonHTMLAttributes, ReactNode } from "react";

export function IconButton({
  label,
  danger = false,
  children,
  className = "",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  danger?: boolean;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className={`icon-btn${danger ? " is-danger" : ""}${className ? ` ${className}` : ""}`}
      aria-label={label}
      title={label}
      {...props}
    >
      {children}
    </button>
  );
}
